/* eslint-disable import/prefer-default-export */
import PropTypes from 'prop-types';

const CountryType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
});

export { CountryType };
